import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LayoutContainer from "../../../components/LayoutsContainer";
import { AccordionActions, Button, Divider, Grid } from "@material-ui/core";
import TitleContainer from "../../LogoLinks/TitleContainer";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useHistory, useParams } from "react-router-dom";
import PagesTitle from "../../../components/Common/PagesTitle";
import UseMobile from "../../../hooks/useIsMobile";
import HTMLReactParser from "html-react-parser";
import AccordionList from "../../../components/AccordionList";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0vh 0vw 5vh 0vw",
    [theme.breakpoints.down("md")]: {
      padding: "2vh 0vw",
    },
  },
  achievementContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
    },
  },
  readmoreBtn: {
    borderRadius: 100,
  },
  description: {
    fontSize: "1rem",
  },
  heading: {
    fontSize: "1.2rem",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  BreadcrumbsContainer: {
    paddingBottom: theme.spacing(2),
  },
  Breadcrumbs: {
    padding: 0,
  },
}));

const GramSchemesLayout = ({ data }) => {
  const { schemeCategory } = useParams();
  console.log("match", schemeCategory);
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const classes = useStyles();
  const history = useHistory();
  const isMobile = UseMobile();
  const handleNavigate = (link, extenral) => {
    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(link);
  };

  const Link = (props) => {
    const { color, href } = props;
    return (
      <Button
        disableFocusRipple
        disableTouchRipple
        disableRipple
        disableElevation
        className={classes.Breadcrumbs}
        onClick={() => handleNavigate(href, false)}
      >
        <Typography color={color}>{props.children}</Typography>
      </Button>
    );
  };
  console.log("schemes", data?.data);

  return (
    <div className={classes.root}>
      <LayoutContainer>
        <div>
          <div className={classes.BreadcrumbsContainer}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" href="/">
                હોમ
              </Link>
              <Link
                color={!schemeCategory ? "textPrimary" : "inherit"}
                href="/gramschemes"
              >
                યોજનાઓ
              </Link>

              {schemeCategory && (
                <Typography color="textPrimary">{schemeCategory}</Typography>
              )}
            </Breadcrumbs>
          </div>
          <Grid
            container
            direction="column"
            alignItems={isMobile ? "center" : "flex-start"}
          >
            <Grid item className={classes.TitleContainer}>
              <PagesTitle title={data.title} />
            </Grid>
          </Grid>
        </div>
        <div className={classes.achievementContainer}>
          <AccordionList data={data?.data} type="scheme" />
        </div>
      </LayoutContainer>
    </div>
  );
};
export default GramSchemesLayout;
